<template>
  <Scaffold :menus="menus" />
</template>
<script>
import Scaffold from "@/components/layout/Scaffold.vue";

export default {
  components: {
    Scaffold,
  },
  data() {
    return {
      currIndex: 0,
      menus: [
        {
          name: "店铺业绩",
          path: "/store-manager/dashboard",
          icon: {
            active: require("@/assets/icons/tab-dashboard-active.svg"),
            inactive: require("@/assets/icons/tab-dashboard-inactive.svg"),
          },
        },
        {
          name: "店铺顾客",
          path: "/store-manager/customers",
          icon: {
            active: require("@/assets/icons/tab-customers-active.svg"),
            inactive: require("@/assets/icons/tab-customers-inactive.svg"),
          },
        },
        {
          name: "店员管理",
          path: "/store-manager/sales",
          icon: {
            active: require("@/assets/icons/tab-stores-active.svg"),
            inactive: require("@/assets/icons/tab-stores-inactive.svg"),
          },
        },
        {
          name: "全部订单",
          path: "/store-manager/orders",
          icon: {
            active: require("@/assets/icons/tab-orders-active.svg"),
            inactive: require("@/assets/icons/tab-orders-inactive.svg"),
          },
        },
        {
          name: "我的",
          path: "/store-manager/my",
          icon: {
            active: require("@/assets/icons/tab-mine-active.svg"),
            inactive: require("@/assets/icons/tab-mine-inactive.svg"),
          },
        },
      ],
    };
  },
};
</script>
